var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFinished(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.50006,
    r: 7.5,
    fill: "#D9F7BE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1753 5.86068C10.4076 6.10419 10.3985 6.48992 10.155 6.72223L7.17415 9.56598C6.93856 9.79073 6.56791 9.79057 6.33251 9.56562L4.84462 8.14374C4.6013 7.91123 4.59255 7.52549 4.82507 7.28218C5.05759 7.03887 5.44332 7.03011 5.68663 7.26263L6.75388 8.28252L9.31374 5.8404C9.55725 5.60809 9.94298 5.61717 10.1753 5.86068Z",
    fill: "#52C41A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 3.23444C5.14416 3.23444 3.23438 5.14422 3.23438 7.50006C3.23438 9.8559 5.14416 11.7657 7.5 11.7657C9.85584 11.7657 11.7656 9.8559 11.7656 7.50006C11.7656 5.14422 9.85584 3.23444 7.5 3.23444ZM2.01562 7.50006C2.01562 4.47112 4.47106 2.01569 7.5 2.01569C10.5289 2.01569 12.9844 4.47112 12.9844 7.50006C12.9844 10.529 10.5289 12.9844 7.5 12.9844C4.47106 12.9844 2.01562 10.529 2.01562 7.50006Z",
    fill: "#52C41A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinished);
export default __webpack_public_path__ + "static/media/Finished.a35bc766.svg";
export { ForwardRef as ReactComponent };